









import { Vue, Prop, Component } from 'vue-property-decorator';
import { ProcessReport } from '@/store/modules/processInterfaces';

@Component({})
export default class ProcessParents extends Vue {
  @Prop() parents!: Array<Partial<ProcessReport>>;
}
